import React from 'react'
import styled from 'styled-components'
import { ArrowDropDown } from '@material-ui/icons'
import { Button, Grid } from '@material-ui/core'
import { svgIconStyle, StyledButton, colors, theme } from '../../../../../theme/Global'

export const CustomArrowDropDown = (
  <ArrowDropDown
    style={svgIconStyle({
      height: '24px',
      width: '24px'
    })}
  />
)

export const TableControls = styled.div`
  margin: 25px auto;
  flex: 0 0 auto;
  flex-direction: row;
`

export const TableLabel = styled.p`
  font-size: 17px;
  font-weight: 600;
  line-height: 18px;
  margin: 0;
`

export const PaidLeaveFilterButton = styled(Button)`
  width: 171px;
  height: 45px;
  border-radius: 8px 8px 0 0 !important;
  background-color: ${colors.lightGrey} !important;
  padding: 0 !important;
  margin: 0 6px 0 0 !important;
  & > span {
    color: ${theme.colors.text};
    font-size: 16px;
    font-weight: 600;
    text-transform: capitalize;
    line-height: 1.3rem;
  }
  &:last-child {
    margin-right: 0 !important;
  }
  &.active,
  &:hover,
  &:active,
  &:focus {
    box-shadow: 0px -2px 4px -1px rgba(0, 0, 0, 0.5);
    background-color: ${colors.backgroundGrey} !important;
    & > span {
      color: ${theme.colors.darkBlueText};
    }
  }
  &:disabled {
    opacity: 0.6;
  }
`

export const TableSearchContainer = styled(Grid)`
  text-align: center;
  margin: 0 0 0 1rem !important;
`

export const LocaleFilterButton = styled(StyledButton)`
  float: left;
  & > span {
    line-height: 18px;
  }
`
